import axiosLib from "axios";
import { API_BASE_URL } from "./config";

const api = axiosLib.create({
  baseURL: API_BASE_URL,
  headers: { "Content-Type": "application/json" },
});

// Mutable getter — null while Auth0 is loading or user is unauthenticated
let _authGetter: (() => Promise<string>) | null = null;

export function setAuthGetter(getter: (() => Promise<string>) | null) {
  _authGetter = getter;
}

api.interceptors.request.use(async (config) => {

  if (config.data instanceof FormData) {
    config.headers.delete("Content-Type");

  }

  if (_authGetter) {
    try {
      const token = await _authGetter();
      config.headers.Authorization = `Bearer ${token}`;
    } catch {
      // Token unavailable — send request without auth (public endpoints)
    }
  }
  return config;
});

api.interceptors.response.use(
  (res) => res,
  (error) => {
    if (error.response?.status === 401) {
      // Session expired — could redirect to login
      console.warn("Session expired or unauthorized");
    }
    return Promise.reject(error);
  }
);

export default api;
